
import { defuFn } from '/Users/cameroncrosby/Dev/dyslexiatutoring_nuxt/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default /* #__PURE__ */ defuFn(inlineConfig)
